import { createFileRoute } from '@tanstack/react-router'

import { GlobalRoleType } from '@beaded/models'

import { requireGlobalRole } from 'lib/routeGuards'

import ServiceManagerOld from 'pages/ServiceManagerOld'

export const Route = createFileRoute('/_auth/_global/service-manager')({
  beforeLoad: requireGlobalRole(
    GlobalRoleType.GLOBAL_EDIT,
    GlobalRoleType.GLOBAL_ADMIN,
  ),
  component: ServiceManagerOld,
})
